import { Table, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";

import { ExportToExcel } from "../../utils/exportExcel";

import { useQuery } from "@tanstack/react-query";
import Something from "../../components/shared/Something";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import { AuthContext } from "../../contexts/AuthContext";
import {
  DeleteOutlined,
  EyeFilled,
  FileExcelOutlined,
  ReloadOutlined,
  CloseSquareFilled,
  CheckSquareFilled,
} from "@ant-design/icons";
import { handleExportServices, handleFetchServices } from "../../api/services";

export default function Services({ status }: any) {
  const { user } = useContext(AuthContext);
  const [requesterModal, setRequesterModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [completeModal, setCompleteModal] = useState<boolean>(false);
  const [isExporting, setExporting] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>(null);
  const access = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const deleteAccess = [9];
  const params = `&u=${user?._id}&a=${user?.accessLevel}`;

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 15,
    total: 0,
  });

  const {
    data: services,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["services", pagination.page, pagination.limit, status],
    queryFn: () =>
      handleFetchServices({
        page: pagination.page,
        limit: pagination.limit,
        status: status || "",
        params,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }
  const getColumns = (user: any, access: any) => {
    const columns: ColumnsType<DataType> = [
      {
        title: "S/N",
        width: 40,
        render: (record: any, text: any, index: any) => (
          <span className="text-gray-700 ml-2">
            {pagination?.page * pagination?.limit -
              pagination?.limit +
              index +
              1}
          </span>
        ),
        fixed: "left",
      },
      {
        title: "CUSTOMER",
        width: 200,
        render: (record: any) => {
          return <div className="text-black">{record?.name || "-"}</div>;
        },
      },
      {
        title: "BRANCH",
        width: 100,
        render: (record: any) => {
          return <div className="text-black">Samora</div>;
        },
      },
      {
        title: "EMAIL",
        width: 180,
        render: (record: any) => {
          return <div className="text-black">{record?.email || "-"}</div>;
        },
      },
      {
        title: "MOBILE",
        width: 180,
        render: (record: any) => {
          return <div className="text-black">{record?.mobile || "-"}</div>;
        },
      },
      {
        title: "VEHICLE",
        width: 120,
        render: (record: any) => {
          return (
            <div className="text-gray-700">
              <div className="">T127BRD</div>
            </div>
          );
        },
      },
      {
        title: "SERVICE",
        width: 300,
        render: (record: any) => (
          <span className="text-gray-700">Minor Service</span>
        ),
      },

      {
        title: "CREATED BY",
        width: 200,
        render: (record: any) => {
          return (
            <button
              onClick={() => {
                setSelected(record);
                setRequesterModal(true);
              }}
              className="text-black"
            >
              {record?.requestedBy?.name || (
                <button
                  onClick={() => {
                    setSelected(record);
                    setRequesterModal(true);
                  }}
                  className="border px-2 py-1 bg-gray-100 shadow-sm"
                >
                  + Assign
                </button>
              )}
            </button>
          );
        },
      },
      {
        title: "CREATED AT",
        width: 140,
        render: (record: any) => (
          <span className="text-gray-700">
            <Moment fromNow>{record?.createdAt}</Moment>
          </span>
        ),
      },
      {
        title: "WIP",
        width: 140,
        render: (record: any) => (
          <span className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm">
            + WIP
          </span>
        ),
      },

      {
        title: "ACTIONS",
        width: 80,
        align: "center",
        fixed: "right",
        render: (record: any) => (
          <div className="flex justify-center">
            <button
              onClick={() => {
                setSelected(record);
                setDeleteModal(true);
              }}
              className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm"
            >
              <DeleteOutlined />
            </button>
          </div>
        ),
      },
      {
        title: "PARTS",
        width: 80,
        align: "center",
        fixed: "right",
        render: (record: any) => (
          <div className="flex justify-end">
            <Link
              to={`/autoline/requests/${record?._id}`}
              className="border py-1 px-2 mx-1 flex items-center bg-blue-50 text-blue-800 shadow-sm"
            >
              <EyeFilled /> <span className="mx-1">Parts</span>
            </Link>
          </div>
        ),
      },
      {
        title: "SYNCED",
        width: 70,
        align: "center",
        fixed: "right",
        render: (record: any) => (
          <div className="flex justify-center text-lg">
            {record?.isSynced ? (
              <div className="text-green-500">
                <CheckSquareFilled width={40} />
              </div>
            ) : (
              <div className="text-red-500">
                <CloseSquareFilled width={80} />
              </div>
            )}
          </div>
        ),
      },
    ];
    return columns.filter((column: any) => {
      if (column.title === "ACTIONS") {
        return deleteAccess.includes(user?.accessLevel);
      }
      return true;
    });
  };
  const columns = getColumns(user, access);

  const exportRequests = async () => {
    setExporting(true);
    const res = await handleExportServices();
    await ExportToExcel(
      res.records?.map((item: any, index: number) => {
        return {
          "S/N": index + 1,
          "Requested For": item?.name || "-",
          User: item?.isNewUser ? "New" : "Existing",
          Email: item?.email || "-",
          Mobile: item?.mobile || "-",
          "For Role": item?.designation || "-",
          Companies: item?.companies?.map((company: any) => company).join(", "),
          Levels: item?.levels?.map((level: any) => level).join(", "),
          "Requested By": item?.requestedBy?.name || "-",
          "Requested At": (
            <Moment format="DD/MM/YYYY">{item?.createdAt}</Moment>
          ),
          "Approved By": item?.approvedBy?.name || "-",
          "Approved At": (
            <Moment format="DD/MM/YYYY">{item?.dateCompleted}</Moment>
          ),
          Status: item?.status || "-",
          Completed: item?.isCompleted ? "Yes" : "No",
        };
      }),
      "Services.xlsx"
    );
    setExporting(false);
  };

  useEffect(() => {
    setPagination({ ...pagination, total: services?.total });
  }, [services]);

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between items-center border px-2">
          <div className="">
            <div className="font-bold capitalize text-lg">All Services</div>
            <div className="text-gray-600 mb-1">Manage all open services</div>
          </div>

          <div className="flex">
            <Tooltip title="Export To Excel">
              <button
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100 shadow-sm"
                onClick={() => exportRequests()}
              >
                {isExporting ? (
                  <ReloadOutlined />
                ) : (
                  <FileExcelOutlined size={20} />
                )}
              </button>
            </Tooltip>
            {/* {access?.includes(user?.accessLevel) && (
              <Link
                to={"/records/new"}
                className="flex mx-2 justify-center items-center border px-4 h-8  bg-karimjee  hover:bg-karimjee-dark text-white shadow-sm"
              >
                + New
              </Link>
            )} */}
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="border p-2 shadow-sm">
            <Table
              size="small"
              dataSource={services?.records}
              columns={columns}
              scroll={{ y: 700, x: "max-content" }}
              rowKey="id"
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              rowClassName={"hover:bg-gray-100 cursor-pointer"}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
          </div>
        )}
      </div>
    </div>
  );
}
